import { render, staticRenderFns } from "./Cria_Empresa.vue?vue&type=template&id=6625772c&"
import script from "./Cria_Empresa.vue?vue&type=script&lang=js&"
export * from "./Cria_Empresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports